import { PhoneOverrideService } from '@weave/schema-gen-ts/dist/schemas/phone/override/v2/override_service.pb';
import { bindHTTP } from '@frontend/schema';

const SchemaPhoneOverrideConfigService = bindHTTP(PhoneOverrideService);

export default SchemaPhoneOverrideConfigService;
